<template>
  <v-row>
    <v-col cols="11">
      <v-col cols="12">
        <h1>
          Cashier Javascript API
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon @click="openInDocs" v-on="on" class="open-docs-icon">mdi-open-in-new</v-icon>
            </template>
            <span>Read more about the cashier's JS API</span>
          </v-tooltip>
        </h1>
      </v-col>
      <div class="px-4">
        <v-btn @click="showPayloadsDataModal.data = true" :disabled="!!!callbackObjects.length" outlined rounded class="success--text my-2" block>
          Callback payload objects ({{ callbackObjects.length }})
        </v-btn>
      </div>
      <v-col cols="12">
        <v-autocomplete
          filled
          :items="allConfigProps"
          v-model="configProp"
          label="Choose a config property and update it's value to trigger the api.set() method"
          @change="configChange"
        ></v-autocomplete>
        <v-text-field
          v-model="inputValue"
          label="Input value"
        ></v-text-field>
        <div class="body-2 pb-4">
          Available options: {{ availableOptions }}
        </div>
        <v-btn @click="triggerUpdate" :disabled="!inputValue.length > 0" outlined rounded class="theme-main-color">
          Trigger update
        </v-btn>
      </v-col>
      <v-col cols="12">
        <prism-editor
          autofocus
          class="js-editor"
          :code="code"
          language="javascript"
        ></prism-editor>
      </v-col>
    </v-col>
    <v-col cols="1">
      <Cashier />
    </v-col>

    <JsApiPayloadModal
      :showPayloadsDataModal="showPayloadsDataModal"
      :callbackObjects="callbackObjects"
    />

  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Cashier from '@/components/Cashier'
import JsApiPayloadModal from '@/components/JsApiPayloadModal'
import { configsInfo } from '@/utils/allConfigs'
import PrismEditor from 'vue-prism-editor'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'Js-api',
  components: {
    PrismEditor,
    Cashier,
    JsApiPayloadModal
  },
  data: () => ({
    inputValue: '',
    code: 'Callback logs . . . ',
    configProp: 'method',
    callbackObjects: [],
    showPayloadsDataModal: { data: false },
    configChanges: {},
    excludeEvents: [
      'SET_CSS'
    ]
  }),
  methods: {
    ...mapActions([ 'setConfigs' ]),
    openInDocs () {
      window.open('https://docu-portal.paymentiq.io/docs/apis_and_integration/cashier/cashier_javascript_api')
    },
    triggerUpdate () {
      window.CashierInstance.set({ config: { [this.configProp]: this.inputValue } })
      const config = {
        ...this.configChanges,
        [this.configProp]: this.inputValue
      }
      this.configChanges = config
    },
    configChange () {
      this.inputValue = ''
    },
    apiCallbackListener (e) {
      if (this.excludeEvents.includes(e.data.eventType)) return null

      if (e.data.eventType) {
        console.log(`Cashier callback: ${e.data.eventType}`)
        console.log(e.data)
      }
      if (e.data.payload && e.data.payload.config) {
        let prop = Object.keys(e.data.payload.config)[0]
        this.code = this.code + '\n' + `Passed in data was set as: "${prop}: ${e.data.payload.config[prop]}"`
      } else {
        let payloadData = ''
        if (e.data.payload) {
          const payloadObj = {
            type: e.data.eventType,
            payload: e.data.payload,
            id: Math.random() * 500
          }
          this.callbackObjects.push(payloadObj)
          payloadData = `Data: "{ Payload Object }"`
        }
        try {
          const payloadKeys = Object.keys(e.data.payload)
          const keyValueAsStr = JSON.stringify(e.data.payload[payloadKeys[0]])
          if (payloadKeys.length === 1 && keyValueAsStr.length < 70) {
            payloadData = `${payloadKeys[0]}: ${keyValueAsStr}`
          }
        } catch (err) { }
        if (!e.data.eventType) return
        this.code = this.code + '\n' + `Event type: ${e.data.eventType}. ${payloadData}`
      }
      const logContainer = this.$el.querySelector('pre')
      logContainer.scrollTop = logContainer.scrollHeight
    }
  },
  computed: {
    ...mapState({
      config: ({ context }) => context.config
    }),
    getConfigs () {
      return configsInfo()
    },
    allConfigProps () {
      const { getConfigs } = this
      const arr = []
      for (let i in getConfigs) {
        arr.push(i)
      }
      return arr
    },
    availableOptions () {
      const { getConfigs } = this
      let options = null
      if (getConfigs[this.configProp].options) {
        options = [ ...getConfigs[this.configProp].options ]
      } else {
        options = typeof getConfigs[this.configProp].val
        if (getConfigs[this.configProp].val === null) options = 'string'
      }
      return options
    }
  },
  mounted () {
    window.addEventListener('message', this.apiCallbackListener)
    const logger = document.querySelector('pre')
    logger.style.maxHeight = '320px'
    logger.style.overflowY = 'auto'
    this.configChanges = { ...this.config }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.apiCallbackListener)
    this.setConfigs(this.configChanges)
  }
}
</script>
